import React from 'react';

import { useAsyncEffect } from '@/hooks/useAsyncEffect';
import { NamedIdentified } from '@/types/namedIdentified';

export const useStateCities = (
  country: string | undefined,
  state: string | null | undefined,
): readonly NamedIdentified[] => {
  const [cities, setCities] = React.useState<readonly NamedIdentified[]>([]);

  const countryKey = React.useMemo((): string => country?.toLowerCase() ?? '', [country]);

  const fetchStateCities = React.useCallback(async (): Promise<readonly NamedIdentified[]> => {
    if (!state) {
      return [];
    }

    try {
      const stateKey = state.toLowerCase();
      const response = await fetch(`/countries/${countryKey}/${stateKey}/index.json`);

      if (!response.ok) {
        return [];
      }

      const resolved = await response.json();

      if (!resolved) {
        return [];
      }

      return resolved;
    } catch {
      return [];
    }
  }, [countryKey, state]);

  useAsyncEffect(async (): Promise<void> => {
    const stateCities = await fetchStateCities();
    setCities(stateCities);
  }, [fetchStateCities]);

  return cities;
};
